export default __webpack_public_path__ + "static/media/CRM-6.c3bdaa23.png";